import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Button,
  Container,
  Modal,
  ModalBody,
  Alert,
} from "reactstrap";

import { Swiper, SwiperSlide } from "swiper/react";
import classnames from "classnames";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import SwiperCore from "swiper";
import {
  getProductById as onGetProductById,
  addNewOrder as onAddNewOrder,
} from "../../slices/thunks";

import moment from "moment";

import PricingWidgetList from "./PricingWidget";
import SalesChannels from "../../Components/Common/SalesChannels";
import RestrictedChannels from "../../Components/Common/RestrictedChannels";
import { useNavigate, useSearchParams } from "react-router-dom";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedinUser } from "../../utils/StorageManager";
import UpgradeModal from "../../Components/Common/UpgradeModal";

SwiperCore.use([FreeMode, Navigation, Thumbs]);

function ReserveUnits() {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const [customActiveTab, setcustomActiveTab] = useState("1");
  const [searchParams] = useSearchParams();
  const userProfileSession = getLoggedinUser();
  
  // Check if user has free trial
  const hasFreeTrialPlan = userProfileSession?.user_freeType === "trial";
  const pro_id = searchParams.get("pro_id");
  const quantity = searchParams.get("quantity");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const selectProductData = createSelector(
    (state) => state.Products,
    (products) => products
  );
  // Inside your component
  const { product } = useSelector(selectProductData);

  const [acknowledged, setAcknowledged] = useState(false);

  const handleAcknowledgement = (e) => {
    setAcknowledged(e.target.checked);
  };

  useEffect(() => {
    const data = {
      pro_id: pro_id,
    };
    dispatch(onGetProductById(data));
  }, [dispatch, pro_id]);

  const toggleCustom = (tab) => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const placeOrder = (product) => {
    dispatch(
      onAddNewOrder({
        pro_id: product.pro_id,
        quantity: Number(quantity),
      })
    );
  };

  document.title = "Reserve Units | Buyers Club";

  return (
    <div className="page-content">
      <UpgradeModal 
        isOpen={showUpgradeModal} 
        toggle={() => setShowUpgradeModal(false)} 
      />
      <Modal
        isOpen={showConfirm}
        toggle={() => setShowConfirm(!showConfirm)}
        centered={true}
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0">Confirm Order</h5>
          <button
            onClick={() => setShowConfirm(false)}
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <ModalBody className="py-3 px-5">
          <div className="mt-2 ">
            <lord-icon
              src="https://cdn.lordicon.com/gsqxdxog.json"
              trigger="loop"
              colors="primary:#f7b84b,secondary:#f06548"
              style={{ width: "100px", height: "100px" }}
            ></lord-icon>
            <div className="mt-4 pt-2 fs-15">
              <p className="text-muted mb-0">
                <h5>Are you sure to place this order? </h5>
              </p>
            </div>
            <br />
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn w-sm btn-danger"
              data-bs-dismiss="modal"
              onClick={() => setShowConfirm(false)}
            >
              Cancel
            </button>

            <button
              type="button"
              className="btn w-sm btn-success "
              id="send-record"
              onClick={() => {
                placeOrder(product);
              }} // This is the function that will be called when the button is clicked
            >
              Yes, Place it!
            </button>
          </div>
        </ModalBody>
      </Modal>      
      <Container fluid>
        <BreadCrumb title="Reserve Units" />

        {product && (
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row className="gx-lg-5">
                    {product?.pro_imageURLs && (
                      <Col xl={4} md={8} className="mx-auto">
                        <div className="product-img-slider sticky-side-div">
                          <Swiper
                            navigation={true}
                            thumbs={{ swiper: thumbsSwiper }}
                            className="swiper product-thumbnail-slider p-2 rounded bg-light"
                          >
                            <div className="swiper-wrapper">
                              {product?.pro_imageURLs
                                .split(",")
                                .map((subItem, key) => (
                                  <SwiperSlide>
                                    <img
                                      key={key}
                                      src={subItem}
                                      alt=""
                                      className="img-fluid d-block"
                                    />
                                  </SwiperSlide>
                                ))}
                            </div>
                          </Swiper>

                          <div className="product-nav-slider mt-2">
                            <Swiper
                              onSwiper={setThumbsSwiper}
                              slidesPerView={4}
                              freeMode={true}
                              watchSlidesProgress={true}
                              spaceBetween={10}
                              className="swiper product-nav-slider mt-2 overflow-hidden"
                            >
                              <div className="swiper-wrapper">
                                {product?.pro_imageURLs
                                  .split(",")
                                  .map((subItem, key) => (
                                    <SwiperSlide>
                                      <div className="nav-slide-item">
                                        <img
                                          key={key}
                                          src={subItem}
                                          alt=""
                                          className="img-fluid d-block"
                                        />
                                      </div>
                                    </SwiperSlide>
                                  ))}
                              </div>
                            </Swiper>
                          </div>
                        </div>
                      </Col>
                    )}

                    <Col xl={8}>
                      <div className="mt-xl-0 mt-5">
                        <div className="d-flex">
                          <div className="flex-grow-1">
                            <h4>{product?.pro_name}</h4>
                            <div className="hstack gap-3 flex-wrap">
                              <span
                                className={
                                  product?.pro_status === 0
                                    ? "badge rounded-pill bg-success text-dark"
                                    : "badge rounded-pill bg-danger text-dark"
                                }
                              >
                                {product?.pro_status === 0
                                  ? "active"
                                  : "inactive"}
                              </span>
                              <div className="text-muted">
                                Product codes :{" "}
                                <span className="text-body fw-medium">
                                  <span>
                                    {product?.pro_UPCCode
                                      ? product?.pro_UPCCode
                                      : "No UPC Code"}
                                    {product?.pro_ASIN && (
                                      <span> / {product?.pro_ASIN}</span>
                                    )}
                                  </span>
                                </span>
                              </div>
                              <div className="text-muted">
                                Vetted Channel(s) :{" "}
                                <SalesChannels
                                  channel={product?.pro_salesChannel}
                                />
                              </div>
                              <div className="text-muted">
                                Restricted Channel(s) :{" "}
                                <RestrictedChannels
                                  channel={product?.pro_restrictedChannel}
                                />
                              </div>
                              <div className="vr"></div>
                              <div className="text-muted">
                                Published :{" "}
                                <span className="text-body fw-medium">
                                  {moment(product?.pro_lastModifiedDate).format(
                                    "MMM Do YY"
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        {product?.pro_extendedLeadTime && (
                          <div className="d-flex m-1">
                            <i className="ri-time-line me-2 text-danger" />
                            <span className="fw-medium text-danger">
                              Extended Lead Time:{" "}
                              {product?.pro_extendedLeadTime} days
                            </span>
                          </div>
                        )}
                        {product?.pro_MAP > 0 && (
                          <div className="d-flex m-1">
                            <i className="ri-price-tag-3-line me-2 text-danger" />
                            <span className="text-danger fw-medium">
                              This product is subject to minimum advertise
                              pricing of{" "}
                              {new Intl.NumberFormat("en-US", {
                                style: "currency",
                                currency: "USD",
                              }).format(product?.pro_MAP)}{" "}
                              and cannot be sold on any sales channel below this
                              price.
                            </span>
                          </div>
                        )}
                        {product?.pro_importantNotes && (
                          <div className="d-flex m-1">
                            <span className="text-danger fw-medium">
                              <p>
                                Important notes: {product?.pro_importantNotes}
                              </p>
                            </span>
                          </div>
                        )}
                        {(product?.pro_MAP ||
                          product?.pro_extendedLeadTime ||
                          product?.pro_importantNotes) && (
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="acknowledgeCheckbox"
                              checked={acknowledged}
                              onChange={handleAcknowledgement}
                            />
                            <label
                              className="form-check-label"
                              htmlFor="acknowledgeCheckbox"
                            >
                              I acknowledge and agree to the above terms and
                              notices.
                            </label>
                          </div>
                        )}
                        {product != null && (
                          <>
                            <Row className="mt-4">
                              <PricingWidgetList
                                pricingDetails={{
                                  icon: "ri-money-dollar-circle-fill",
                                  label: "Price",
                                  labelDetail: `$ ${product?.pro_price}`,
                                }}
                              />
                              <PricingWidgetList
                                pricingDetails={{
                                  icon: "ri-stack-fill",
                                  label: "Quantity",
                                  labelDetail: `${quantity}`,
                                }}
                              />
                              <PricingWidgetList
                                pricingDetails={{
                                  icon: "ri-money-dollar-circle-fill",
                                  label: "Total Price",
                                  labelDetail: `$ ${(
                                    product?.pro_price * quantity
                                  ).toFixed(2)}`,
                                }}
                              />
                            </Row>
                            <Row>
                              {userProfileSession?.user_stripeDefaultPaymentMethodId ==
                                null ||
                              userProfileSession?.user_sellerCloudCompanyId ==
                                null ||
                              userProfileSession?.user_sellerCloudCompanyId ==
                                0 ? (
                                <>
                                  <Alert color="danger">
                                    <div className="d-flex align-items-center">
                                      <i className="ri-alert-fill fs-20 me-2"></i>
                                      <div>
                                        <h5 className="mb-0">
                                          Payment Method Required
                                        </h5>
                                        <p className="mb-0">
                                          You need to add a payment method for
                                          purchases to place an order.
                                        </p>
                                      </div>
                                    </div>
                                  </Alert>
                                  <button
                                    type="button"
                                    className="btn w-sm btn-success "
                                    id="send-record"
                                    onClick={() => {
                                      navigate("/billing");
                                    }} // This is the function that will be called when the button is clicked
                                  >
                                    Go to billing
                                  </button>
                                </>
                              ) : product?.pro_availableStock > 0 ? (
                                <Col lg={3} sm={6}>
                                  <Button
                                    color="primary"
                                    className="mt-3"
                                    onClick={() => {
                                      if (hasFreeTrialPlan) {
                                        setShowUpgradeModal(true);
                                      } else {
                                        setShowConfirm(true);
                                      }
                                    }}
                                  >
                                    Place Order
                                  </Button>
                                </Col>
                              ) : (
                                <Col lg={3} sm={6}>
                                  <Alert color="danger">
                                    <div className="d-flex align-items-center">
                                      <i className="ri-alert-fill fs-20 me-2"></i>
                                      <div>
                                        <h5 className="mb-0">
                                          This product is out of stock
                                        </h5>
                                      </div>
                                    </div>
                                  </Alert>
                                </Col>
                              )}
                            </Row>
                          </>
                        )}
                        <div className="product-content mt-5">
                          <Nav tabs className="nav-tabs-custom nav-success">
                            <NavItem>
                              <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                  active: customActiveTab === "1",
                                })}
                                onClick={() => {
                                  toggleCustom("1");
                                }}
                              >
                                Specification
                              </NavLink>
                            </NavItem>
                          </Nav>

                          <TabContent
                            activeTab={customActiveTab}
                            className="border border-top-0 p-4"
                            id="nav-tabContent"
                          >
                            <TabPane id="nav-speci" tabId="1">
                              <div className="table-responsive">
                                <table className="table mb-0">
                                  <tbody>
                                    <tr>
                                      <th
                                        scope="row"
                                        style={{ width: "200px" }}
                                      >
                                        Category
                                      </th>
                                      <td>{product?.pro_categoryName}</td>
                                    </tr>
                                    <tr>
                                      <th scope="row">Brand</th>
                                      <td>{product?.pro_brand}</td>
                                    </tr>
                                    <tr>
                                      <th scope="row">Weight</th>
                                      <td>
                                        {product?.pro_shippingWeight}{" "}
                                        {product?.pro_shippingWeightUnit}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th scope="row">Dimensions</th>
                                      <td>
                                        {product?.pro_dimLength} x{" "}
                                        {product?.pro_dimWidth} x{" "}
                                        {product?.pro_dimHeight}{" "}
                                        {product?.pro_dimUnit}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </TabPane>
                          </TabContent>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
}

export default ReserveUnits;
